import {
  PasswordInput as MantinePasswordInput,
  type PasswordInputProps as MantinePasswordInputProps,
} from "@mantine/core";
import { type ChangeEvent, type ForwardedRef, forwardRef } from "react";
import type { FieldValues, Path, PathValue } from "react-hook-form";

export type PasswordInputProps = MantinePasswordInputProps;
type Props<FORM_TYPE extends FieldValues> = {
  onChange?:
    | ((value: string) => void)
    | ((
        event: ChangeEvent<Element> | PathValue<FORM_TYPE, Path<FORM_TYPE>>,
      ) => void);
  value?: string;
} & Omit<PasswordInputProps, "onChange">;

export const PasswordInput = forwardRef(function PasswordInputs<
  FORM_TYPE extends FieldValues,
>(props: Props<FORM_TYPE>, ref: ForwardedRef<HTMLInputElement>) {
  const { ...inputProps } = props;
  // const _ref = useRef<HTMLInputElement>(null);
  // const mergedRef = useMergedRef(ref, _ref);
  const defaultOption: PasswordInputProps = {};
  const option = Object.assign({}, defaultOption, inputProps);
  return <MantinePasswordInput {...option} />;
});
